// extracted by mini-css-extract-plugin
export var localeSelector = "_b2-0";